<template>
    <div class="row">
        <div class="documentation">
            <div class="documentation-container">
                <nav aria-label="breadcrumb" class="d-none d-xl-block">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a v-bind:href="'/docs/'">Документы</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Список документов</li>
                    </ol>
                </nav>
                <div class="title-block">
                    <div class="title-block__left">
                        <div class="title-block__title">
                            Список документов
                        </div>
                        <a class="title-block__btn btn-add btn-primary btn" href="#" @click.prevent="showModalAdd">
                            Добавить
                        </a>

                    </div>
                </div>

                <div class="row g-2 mb-4">
                    <div class="col-8">
                        <v-select
                            v-model="modelClient"
                            :items="clientOptions"
                            @update:modelValue="onClientChange($event)"
                            @update:menu="$removeFocus"
                            @click:clear="$removeFocus"
                            @click:control="$removeFocus"
                            label="Фильтр по клиенту"
                            item-title="label"
                            item-value="value"
                            variant="outlined"
                            color="primary"
                            density="compact"
                            clearable>
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>
                </div>

                <div class="row g-2 mb-4">
                    <div class="col-8">
                        <div class="search-control doc-search-control">
                            <input type="text" class="search-control__input form-control" placeholder="Поиск"
                                @input="resetChoice"
                                @change="docSearch"
                                v-model="searchQuerry">
                            <button class="search-control__input-btn reset-btn" @click="docSearch">
                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"
                                        fill="currentColor"></path>
                                </svg>
                            </button>
                            <!-- <ul class="search-suggestions doc-suggestions" :class="{ open: suggestionsOpen }" @click.prevent="docSuggesttionsHandler" > -->

                            <!-- </ul> -->
                        </div>
                    </div>
                </div>

                <div class="doc-table-responsive table-responsive">
                    <table class="doc-table table">
                        <thead>
                        <tr :class="'open'">
                            <th>

                            </th>
                            <th>
                                <div class="th-inner ">
                                    Название документа
                                </div>
                            </th>
                            <th>
                                Создан/Изменен
                            </th>
                            <th>

                            </th>
                        </tr>
                        </thead>

                        <tbody>
                            <tr v-if="!searchResult[0] || searchQuerry === ''" v-for="data in result"
                                    :id="`editPageTr${data.id}${data.element}`"
                                    v-bind:class="data.parent_class"
                                    :class="[
                                        { 'open': data.element == 'software' || getLsId(`editPageTr${data.id}${data.element}`) == true},
                                        { 'highlighted': data.id == prevPageUrl }
                                    ]">
                                <td>
                                    <div v-if="data.element == 'page'"
                                        class="doc-table-state"
                                        :class="{ active: data.visible == 1 }">
                                    </div>
                                </td>
                                <td>
                                    <div v-if="data.element == 'software'"
                                            class="table-item"
                                            :class="{ 'has-list': data.has_child == 1 }">
                                        <button class="table-item__toggle reset-btn"
                                            :id="`editPageBtn${data.id}${data.element}`"
                                            :class="{ 'open': getLsId(`editPageBtn${data.id}${data.element}`) == true }"
                                            @click.prevent="docOpenHandler($event, data)">
                                        </button>
                                        <span class="table-item__icon vol"></span>
                                        <span class="table-item__title">
						    				{{ data.name }}
						    			</span>
                                        <div class="table-item-container">
                                            <button class="table-item__add-section reset-btn"
                                                @click.prevent="addItem({element: 'version', software: data.id})">
                                                Добавить версию
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="data.element == 'version'"
                                            class="table-item"
                                            :style="{ marginLeft: data.indent + 'px' }"
                                            :class="{ 'has-list': data.has_child == 1 }">
                                        <button class="table-item__toggle reset-btn"
                                            :id="`editPageBtn${data.id}${data.element}`"
                                            :class="{ 'open': getLsId(`editPageBtn${data.id}${data.element}`) == true }"
                                            @click.prevent="docOpenHandler($event, data)">
                                        </button>
                                        <span class="table-item__title">
						    				Версия {{ data.name }}
						    			</span>
                                        <div class="table-item-container">
                                            <button class="table-item__add-section reset-btn"
                                                @click.prevent="addItem({element: 'document', version: data.id})">
                                                    Добавить раздел
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="data.element == 'document'"
                                            class="table-item"
                                            :style="{ marginLeft: data.indent + 'px' }"
                                            :class="{ 'has-list': data.has_child == 1 }">
                                        <button class="table-item__toggle reset-btn"
                                            :id="`editPageBtn${data.id}${data.element}`"
                                            :class="{ 'open': getLsId(`editPageBtn${data.id}${data.element}`) == true }"
                                            @click.prevent="docOpenHandler($event, data)">
                                        </button>
                                        <span class="table-item__icon list"></span>
                                        <span class="table-item__title">
						    				{{ data.name }}
						    			</span>
                                    </div>

                                    <div v-if="data.element == 'page'"
                                            class="table-item"
                                            :style="{ marginLeft: data.indent + 'px' }"
                                            :class="{ 'has-list': data.has_child == 1 }">
                                        <button class="table-item__toggle reset-btn"
                                            :id="`editPageBtn${data.id}${data.element}`"
                                            :class="{ 'open': getLsId(`editPageBtn${data.id}${data.element}`) == true }"
                                            @click.prevent="docOpenHandler($event, data)">
                                        </button>
                                        <span class="table-item__icon doc"
                                            :class="{ small: data.parent_id > 1 }">
                                        </span>
                                        <span class="table-item__title">
                                            {{ data.name }}
                                        </span>
                                    </div>

                                </td>
                                <td>
                                    <div class="doc-table-times">
                                        <div class="doc-table-times__row created">
                                            {{ data.created_at }}
                                        </div>
                                        <div class="doc-table-times__row edited">
                                            {{ data.updated_at }}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex justify-content-end align-items-center">
                                        <button v-if="data.element == 'software'" class="table-action table-action_user_access m-auto"
                                                title="Редактировать доступ" @click.prevent="editAccess(data)">
                                        </button>

                                        <button v-if="data.type != '5'" class="table-action table-action_status_history m-auto"
                                                title="История">
                                        </button>

                                        <button v-if="data.element == 'page' && data.visible == 1"
                                                class="table-action table-action_doc_link m-auto" title="Получить ссылку" @click.prevent="getPageLink(data.id)">
                                        </button>

                                        <button v-if="data.type != '5'"
                                                class="table-action table-action_edit m-auto" title="Редактировать" @click.prevent="editElement(data)">
                                        </button>

                                        <button v-if="data.type != '5'" title="Удалить"
                                                class="table-action table-action_delete m-auto" @click.prevent="showModalDelete( data.id, data.element)">
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <tr v-else v-for="data in searchResult"
                                    :id="`editPageTr${data.id}${data.element}`"
                                    v-bind:class="`${data.parent_class} open`">
                                <td>
                                    <div v-if="data.element == 'page'"
                                        class="doc-table-state"
                                        :class="{ active: data.visible == 1 }">
                                    </div>
                                </td>
                                <td>
                                    <div v-if="data.element == 'software'"
                                            class="table-item"
                                            :class="{ 'has-list': data.has_child == 1 }">
                                        <button class="table-item__toggle reset-btn open"
                                            :id="`editPageBtn${data.id}${data.element}`"
                                            @click.prevent="docOpenHandler($event, data)">
                                        </button>
                                        <span class="table-item__icon vol"></span>
                                        <span class="table-item__title">
						    				{{ data.name }}
						    			</span>
                                        <div class="table-item-container">
                                            <button class="table-item__add-section reset-btn"
                                                @click.prevent="addItem({element: 'version', software: data.id})">
                                                Добавить версию
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="data.element == 'version'"
                                            class="table-item"
                                            :style="{ marginLeft: data.indent + 'px' }"
                                            :class="{ 'has-list': data.has_child == 1 }">
                                        <button class="table-item__toggle reset-btn open"
                                            :id="`editPageBtn${data.id}${data.element}`"
                                            @click.prevent="docOpenHandler($event, data)">
                                        </button>
                                        <span class="table-item__title">
						    				Версия {{ data.name }}
						    			</span>
                                        <div class="table-item-container">
                                            <button class="table-item__add-section reset-btn"
                                                @click.prevent="addItem({element: 'document', version: data.id})">
                                                    Добавить раздел
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="data.element == 'document'"
                                            class="table-item"
                                            :style="{ marginLeft: data.indent + 'px' }"
                                            :class="{ 'has-list': data.has_child == 1 }">
                                        <button class="table-item__toggle reset-btn open"
                                            :id="`editPageBtn${data.id}${data.element}`"
                                            @click.prevent="docOpenHandler($event, data)">
                                        </button>
                                        <span class="table-item__icon list"></span>
                                        <span class="table-item__title">
						    				{{ data.name }}
						    			</span>
                                    </div>

                                    <div v-if="data.element == 'page'"
                                            class="table-item"
                                            :style="{ marginLeft: data.indent + 'px' }"
                                            :class="{ 'has-list': data.has_child == 1 }">
                                        <button class="table-item__toggle reset-btn"
                                            :id="`editPageBtn${data.id}${data.element}`"
                                            :class="{ 'open': getLsId(`editPageBtn${data.id}${data.element}`) == true }"
                                            @click.prevent="docOpenHandler($event, data)">
                                        </button>
                                        <span class="table-item__icon doc"
                                            :class="{ small: data.parent_id > 1 }">
                                        </span>
                                        <span class="table-item__title">
                                            {{ data.name }}
                                        </span>
                                    </div>

                                </td>
                                <td>
                                    <div class="doc-table-times">
                                        <div class="doc-table-times__row created">
                                            {{ data.created_at }}
                                        </div>
                                        <div class="doc-table-times__row edited">
                                            {{ data.updated_at }}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex justify-content-end align-items-center">
                                        <button v-if="data.element == 'software'" class="table-action table-action_user_access m-auto"
                                                title="Редактировать доступ" @click.prevent="editAccess(data)">
                                        </button>

                                        <button v-if="data.type != '5'" class="table-action table-action_status_history m-auto"
                                                title="История">
                                        </button>

                                        <button v-if="data.element == 'page' && data.visible == 1"
                                                class="table-action table-action_doc_link m-auto" title="Получить ссылку" @click.prevent="getPageLink(data.id)">
                                        </button>

                                        <button v-if="data.type != '5'"
                                                class="table-action table-action_edit m-auto" title="Редактировать" @click.prevent="editElement(data)">
                                        </button>

                                        <button v-if="data.type != '5'" title="Удалить"
                                                class="table-action table-action_delete m-auto" @click.prevent="showModalDelete( data.id, data.element)">
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

        <modal-window ref="modaladd">
            <template v-slot:title>
                <div class="modal-header">
                    <h5 class="modal-title w-100 text-center">Добавить новый элемент</h5>
                </div>
            </template>
            <template v-slot:body>
                <div class="modal-body">
                    <v-select
                        v-model="modaldata"
                        :items="[{label: 'Не выбрано'}, {element: 'software', label: 'Программа'}, {element: 'page', label: 'Статья'}]"
                        item-title="label"
                        item-value="element"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        clearable
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>
            </template>
            <template v-slot:footer>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click.self="addItem(modaldata)"> Далее </button>
                    <button type="button" class="btn btn-lg btn-outline-dark" @click.self="closeModalAdd"> Отменить </button>
                </div>
            </template>
        </modal-window>

        <modal-window ref="modaldelete">
            <template v-slot:title>
                <div class="modal-header">
                    <h5 class="modal-title w-100 text-center">Вы точно хотите удалить ?</h5>
                </div>
            </template>

            <template v-slot:body>
                <div class="modal-body">
                    <p class="text-center color-light">Данное действие нельзя отменить</p>
                </div>
            </template>
            <template v-slot:footer>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click.self="deleteItem(modaldata.id, modaldata.element)"> Удалить </button>
                    <button type="button" class="btn btn-lg btn-outline-dark" @click.self="closeModalDelete"> Отменить </button>
                </div>
            </template>
        </modal-window>

        <modal-window ref="modaledit">
            <template v-slot:title>
                <div class="modal-header">
                    <h5 class="modal-title w-100 text-center">{{ modaldata.title }}</h5>
                </div>
            </template>
            <template v-slot:body>
                <div class="modal-body">
                    <div>
                        <label v-if="modaldata.label === 'Номер версии'" for="name" class="form-label">
                            {{ modaldata.label }}
                            <svg style="cursor: help;" @mouseenter="toggleLinkNotification" @mouseleave="toggleLinkNotification" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 7.5H10.0083M9.16667 10H10V13.3333H10.8333M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10Z" stroke="#575F6E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            <div class="input-notification__wrapper">
                                <div class="input-notification"
                                    :class="{ 'visible': linkNotification, 'hidden': !linkNotification }">
                                    <div class="input-notification__text">
                                        Ввод только цифр и точек (например, 1.23) без каких-либо других символов
                                    </div>
                                </div>
                            </div>

                        </label>
                        <label v-else for="name" class="form-label">
                            {{ modaldata.label }}
                        </label>
                        <input v-if="modaldata.label === 'Номер версии'" type="number" min="1" name="name" class="form-control" v-model="modaldata.name">
                        <input v-else type="text" name="name" class="form-control" v-model="modaldata.name">
                    </div>
                    <div class="modal-response-errors">{{ modaldata.error }}</div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click.self="editItem(modaldata)"> Сохранить </button>
                    <button type="button" class="btn btn-lg btn-outline-dark" @click.self="closeModalEdit"> Отменить </button>
                </div>
            </template>
        </modal-window>

        <modal-window ref="modalaccess">
            <template v-slot:title>
                <div class="modal-header">
                    <h5 class="modal-title w-100 text-center">Редактировать доступ</h5>
                </div>
            </template>
            <template v-slot:body>
                <div class="modal-body">
                    <div>
                        <div class="form-label">Выберите клиента</div>
                        <!-- <v-select class="no-searchable"
                                v-model="modaldata.client"
                                :options="clientOptions"
                                :deselectFromDropdown="false"
                                :multiple="true"
                                :clearable="false">
                            <template #no-options="{ search, searching, loading }">
                                <div class="text-not-found">Не найдено</div>
                            </template>
                        </v-select> -->

                        <v-select
                            v-model="modaldata.client"
                            :items="clientOptions"
                            item-title="label"
                            item-value="value"
                            variant="outlined"
                            color="primary"
                            density="compact"
                            multiple
                            @update:menu="$removeFocus"
                            @click:clear="$removeFocus"
                            @click:control="$removeFocus">
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click.self="editClientAccess(modaldata)">Сохранить</button>
                    <button type="button" class="btn btn-outline-dark" @click.self="closeModalAccess">Отменить</button>
                </div>
            </template>
        </modal-window>

        <modal-window ref="modallinks">
            <template v-slot:title>
                <div class="modal-header">
                    <h5 class="modal-title w-100 text-center">Ссылки на статью</h5>
                </div>
            </template>
            <template v-slot:body>
                <div v-if="modaldata.length > 0" class="modal-body">
                    <div v-for="data in modaldata" class="row mb-4">
                        <div class="col-12">
                            <div class="form-label">Для клиента "{{ data.client }}":</div>
                            <textarea name="" id="documentDescriptionInput" rows="5" class="form-control" >{{ data.url }}</textarea>
                            <a href="#" @click.prevent="copyLink(data.url)">Копировать ссылку</a>
                        </div>
                    </div>
                </div>
                <div v-else class="modal-body">
                    К программе не привязаны клиенты
                </div>
            </template>
            <template v-slot:footer>
                <div class="modal-footer">
                    <button type="button" class="btn btn-lg btn-outline-dark" @click.self="closeModalLinks"> Закрыть </button>
                </div>
            </template>
        </modal-window>
    </div>
</template>

<script>

import ModalWindow from './DocumentationModal.vue';
import { nextTick } from 'vue';

export default {
    name: "DocumentationList",
    components: {
        ModalWindow
    },
    props: [
        'client',
        'clientlist',
        'result',
        'search',
    ],
    data: () => {
        return {
            clientselect: '',
            suggestionsOpen: false,
            parentDoc: '',
            content: '',
            modaldata: '',
            searchQuerry: '',
            clientOptions: [],
            modelClient: null,
            modelTypeSearch: {type: 'sw', label: 'Программы'},
            prevPageUrl: localStorage.getItem('prevPageUrl'),
            linkNotification: false,
            allElements: [],
            prevAllElements: [],
            newElements: [],
            searchResult: []
        };
    },
    created() {
        var list = [];
        this.clientlist.forEach(obj => {
            list.push({
                value: obj.id,
                label: obj.name,
            });
        });
        this.clientOptions = list;

        this.modelClient = this.client.id ? {value: this.client.id, label: this.client.name} : null;

        if (this.search.type && this.search.name) {
            this.modelTypeSearch = {type: this.search.type, label: this.search.name};
        }

        if (this.search.querry) {
            this.searchQuerry = this.search.querry;
        }

    },
    methods: {
        // docSuggesttionsHandler: function (e) {
        //     const target = e.target;
        //     const link = target.closest('a') || false;
        //     if (link) {
        //         const text = link.textContent;
        //         if (text) {
        //             this.parentDoc = text;
        //         }
        //         this.closeSuggestions();
        //     }
        // },
        resetChoice: function (e) {
            this.parentDocIcon = '';
            e.target.parentElement.setAttribute('class', 'search-control doc-search-control');
            // this.openSuggestions();
        },
        // openSuggestions: function () {
        //     this.suggestionsOpen = true;
        // },
        // closeSuggestions: function () {
        //     this.suggestionsOpen = false;
        // },
        deleteItem: function (id, element) {
            axios.delete('/docs-edit/' + element + '/' + id, {})
                .then(res => {
                    if(res.data.status == 'ok') {
                        document.location = '/docs-edit';
                    }
                });
        },

        showModalAdd: function () {
            this.modaldata = {label: 'Не выбрано'};
            this.$refs.modaladd.show = true;
        },

        closeModalAdd: function () {
            this.$refs.modaladd.show = false;
        },

        showModalDelete: function (id, element) {
            this.modaldata = {id: id, element: element};
            this.$refs.modaldelete.show = true;
        },

        closeModalDelete: function () {
            this.$refs.modaldelete.show = false;
        },

        closeModalEdit: function () {
            if (this.modaldata.name) {
                this.modaldata.name = '';
                this.modaldata.error = '';
            }
            this.$refs.modaledit.show = false;
        },

        closeModalAccess: function () {
            this.$refs.modalaccess.show = false;
        },

        closeModalLinks: function () {
            this.$refs.modallinks.show = false;
        },

        onClientChange(events) {
            var url = '';
            this.clientlist.forEach(obj => {
                if(events == obj.id) {
                    url = obj.url;
                }
            });
            document.location = '/docs-edit?client=' + url;
        },

        editElement: function (data) {
            window.location.href = 'https://docs.d-services.ru';
            this.modaldata = data;
            switch(data.element) {
                case 'software':
                    this.modaldata.title = 'Редактировать программу';
                    this.modaldata.label = 'Название программы';
                    this.$refs.modaledit.show = true;
                    break;
                case 'version':
                    this.modaldata.title = 'Редактировать версию';
                    this.modaldata.label = 'Номер версии';
                    this.$refs.modaledit.show = true;
                    break;
                case 'document':
                    this.modaldata.title = 'Редактировать раздел';
                    this.modaldata.label = 'Название раздела';
                    this.$refs.modaledit.show = true;
                    break;
                case 'page':
                    document.location = '/docs-edit/page/' + data.id;
                    break;
            }

        },

        editItem: function (data) {
            if (data.name < 1) {
                this.modaldata.error = 'Номер версии должен быть числом не меньше 1';
                return; // Прекращаем выполнение, не отправляем запрос
            }
            axios.post('/docs-edit', data)
                .then(res => {
                    if(res.data.status == 'error') {
                        this.modaldata.error = res.data.message;
                    } else if(res.data.status == 'ok') {
                        document.location = '/docs-edit';
                    }
                });
        },

        addItem: function (data) {
            window.location.href = 'https://docs.d-services.ru';
            let item = data?.element ? data?.element : data;
            if(item !== 'Не выбрано') {
                this.$refs.modaladd.show = false;
                switch(item) {
                    case 'software':
                        this.modaldata = {name: ''};
                        this.modaldata.title = 'Добавить программу';
                        this.modaldata.label = 'Название программы';
                        this.modaldata.element = 'software';
                        this.$refs.modaledit.show = true;
                        break;
                    case 'version':
                        this.modaldata = {name: ''};
                        this.modaldata.title = 'Добавить версию';
                        this.modaldata.label = 'Номер версии';
                        this.modaldata.element = 'version';
                        this.modaldata.sw_id = data.software;
                        this.$refs.modaledit.show = true;
                        break;
                    case 'document':
                        this.modaldata = {name: ''};
                        this.modaldata.title = 'Добавить раздел';
                        this.modaldata.label = 'Название раздела';
                        this.modaldata.element = 'document';
                        this.modaldata.vers_id = data.version;
                        this.$refs.modaledit.show = true;
                        break;
                    case 'page':
                        document.location = '/docs-edit/page';
                        break;
                }
            }
        },

        editAccess: function (data) {
            data.type = 'get';
            axios.post('/docs-edit/access', data)
                .then(res => {
                    if(res.data.status == 'ok') {
                        this.modaldata = {software: data.id};
                        this.modaldata.client = [];
                        res.data.softwareClients.forEach(client => {
                            this.clientlist.forEach(obj => {
                                if(obj.id == client.client_id) {
                                    this.modaldata.client.push({
                                        value: obj.id,
                                        label: obj.name
                                    });
                                }
                            });
                        });
                        this.$refs.modalaccess.show = true;

                    }
                });
        },

        editClientAccess(data) {
            let arrData = [];

            data.client.forEach(client => {
                arrData.push({ value: client })
            });

            axios.post('/docs-edit/access', {
                ...data,
                type: 'set',
                client: arrData
            }).then(res => {
                if (res.data.status === 'ok') {
                    this.$refs.modalaccess.show = false;
                }
            });
        },

        getPageLink: function (id) {
            axios.post('/docs-edit/page-link', {id: id})
                .then(res => {
                    if(res.data.status == 'ok') {
                        this.modaldata = res.data.links;
                        this.$refs.modallinks.show = true;
                    }
                });
        },

        copyLink: function (link) {
            navigator.clipboard.writeText(link)
        },

        docOpenHandler: function (event, data) {
            const target = event.target;

            if(target.classList.contains('open')) {
                localStorage.removeItem(target.id);
                target.classList.remove('open');

                var objects = document.getElementsByClassName('pp_' + data.element + '_' + data.id);
                for(var obj of objects) {
                    var child = obj.querySelector('.table-item__toggle');
                    obj.classList.remove('open');
                    localStorage.removeItem(obj.id)
                    child.classList.remove('open');
                    localStorage.removeItem(child.id)
                }
            } else {
                target.classList.add('open');
                localStorage.setItem(event.target.id, true)

                var objects = document.getElementsByClassName('p_' + data.element + '_' + data.id);
                for(var obj of objects) {
                    obj.classList.add('open');
                    localStorage.setItem(obj.id, true)
                }
            }
        },

        getLsId (elementId) {
            return Boolean(localStorage.getItem(elementId))
        },

        searchData: function () {
            document.location = '/docs-edit?search_type=' + this.modelTypeSearch.type + '&search_querry=' + this.searchQuerry;
        },

        getPrevPageId: function () {
            let url = localStorage.getItem('prevPageUrl')
            if (url !== null) {
                let lastSlashIndex = url.lastIndexOf('/');
                this.prevPageUrl = url.substring(lastSlashIndex + 1);
            }
        },

        getAllElements: function() {
            if (!localStorage.getItem('allElementsIds')) {
                localStorage.setItem('allElementsIds', this.allElements)
            }

            this.result.forEach(element => {
                this.allElements.push(`editPageBtn${element.id}${element.element}`)
                this.allElements.push(`editPageTr${element.id}${element.element}`)
            })

            if (localStorage.getItem('allElementsIds')) {
                this.prevAllElements = localStorage.getItem('allElementsIds').split(',')

                this.allElements.forEach(element => {
                    if (!this.prevAllElements.includes(element)) {
                        this.newElements.push(element);
                    }
                })

                this.newElements.forEach(elem => {
                    const ids = elem.match(/\d+/g).join('');

                    if (elem.includes(`Tr${ids}version`)) {
                        const swIds = document.getElementById(elem).className.split(' ')[0].match(/\d+/g).join('');
                        const buttonId = `editPageBtn${swIds}software`

                        document.getElementById(buttonId).classList.add('open');
                        localStorage.setItem(buttonId, true);

                        this.result.forEach(element => {
                            if (element.id == ids) {
                                if (element.sw_id == swIds) {
                                    for (let element of document.getElementsByClassName(element.parent_class)) {
                                        element.classList.add('open');
                                        localStorage.setItem(element.id, true);
                                    }
                                }
                            }
                        })
                    } else if (elem.includes(`Tr${ids}document`)) {
                        const versIds = document.getElementById(elem).className.split(' ')[1].match(/\d+/g).join('');
                        const buttonId = `editPageBtn${versIds}version`
                        document.getElementById(buttonId).classList.add('open');
                        localStorage.setItem(buttonId, true);
                        this.result.forEach(element => {
                            if (element.id == ids) {
                                if (element.vers_id == versIds) {
                                    for (let element of document.getElementsByClassName(element.parent_class)) {
                                        element.classList.add('open');
                                        localStorage.setItem(element.id, true);
                                    }
                                }
                            }
                        })
                    } else if (elem.includes(`Tr${ids}page`)) {
                        localStorage.setItem(`editPageTr${ids}page`, true)
                    }
                })
            }
            localStorage.setItem('allElementsIds', this.allElements)
        },

        scrollToHighlighted() {
            nextTick(() => {
                const highlightedElement = this.$el.querySelector('.highlighted');
                if (highlightedElement) {
                    highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },

        toggleLinkNotification() {
            this.linkNotification = !this.linkNotification
        },

        docSearch() {
            this.searchResult = [];

            this.result.forEach((element, index) => {
                if (element.name.toLowerCase().includes(this.searchQuerry.toLowerCase()) && !this.searchResult.includes(element)) {
                    this.searchResult.push(element);
                    let indent = element.indent;

                    for (let i = index - 1; i >= 0; i--) {
                        if (this.result[i].indent < indent) {
                            indent = this.result[i].indent;
                            this.searchResult.push(this.result[i])
                            if (this.result[i].indent <= 0) {
                                break;
                            }
                        }
                    }
                }
            });
            this.searchResult = this.searchResult.reverse();
        }
    },
    mounted() {
        this.getAllElements();
        this.getPrevPageId();
        this.scrollToHighlighted();
        // document.addEventListener("keydown", (e) => {
        //     if (e.key == 'Escape') {
        //         this.closeSuggestions();
        //     }
        // });
        // document.addEventListener("click", (e) => {
        //     if (!e.target.closest('.doc-search-control')) {
        //         this.closeSuggestions();
        //     }
        // });
    },
};
</script>

<style scoped lang="scss">
    @keyframes fadeIn{
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes fadeOut{
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
    .highlighted {
        background-color: #D8EBFF;
    }
    .visible {
    animation-name: fadeIn;
    animation-duration: 0.3s;
    display: flex;
    }
    .hidden {
        animation-name: fadeOut;
        animation-duration: 0.3s;
        display: none;
    }
    .input-notification {
    position: absolute;
    top: -46px;
    left: 140px;
    background-color: #fff;
    border-color: #eee;
    border-radius: 10px;
    border-style: solid;
    border-width: 0;
    box-shadow: 0 16px 16px -10px rgba(34,47,62,.15),
    0 0 40px 1px rgba(34,47,62,.15);
    flex-direction: column;
    max-height: 235px;
    width: 277px;
    z-index: 10;

    &__wrapper {
        position: relative;
    }
    &__text {
        padding: 15px;
        font-size: 12px;
        line-height: 18px;
    }
    &::before {
        content: '';
        position: absolute;
        bottom: 30%;
        left: -12px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-bottom: 10px solid transparent;
        border-left: 10px solid transparent;
        border-right: 15px solid rgb(255, 255, 255);
        border-top: 10px solid transparent;
        z-index: 999;
    }
}
</style>
